/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ScrollMenu from 'react-horizontal-scrolling-menu';

import { toast } from 'react-toastify'; //토스트(toast)
//import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import CharItem from '../components/char/CharItem';

class ProfileEdit extends Component {
  state = {
    mouseOn: false,
    slideIndex: 1,
    afterChar: '',
    file: '',
    previewURL: '',
  };
  componentDidMount = () => {
    this._getMyChar();
    this._getIvent();
  };
  _getIvent = async () => {
    //const { loginId } = this.props;
    const result = await this._getInvenApi();
    const intReturn = result.data[0].intReturn;
    const invenList = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        invenList,
      });
    }
  };

  _getInvenApi = () => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/inven', {})
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _getMyChar = async () => {
    const { loginId, pkg, history } = this.props;

    if (
      loginId === null ||
      loginId === undefined ||
      loginId === '' ||
      pkg === null ||
      pkg === undefined ||
      pkg === ''
    ) {
    } else {
      const result = await this._getMyCharApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        const myCharData = result.data[0].listData;

        if (intReturn === 0) {
          this.setState({
            myCharData,
            afterChar: myCharData[0].myCharImg,
            previewURL:
              myCharData[0].gubun === 'I' ? myCharData[0].myCharImg : '',
          });
        } else {
          history.push('/');
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _getMyCharApi = () => {
    const { apiUrl, loginId, pkg, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');

    return axios
      .post(
        apiUrl + '/myChar_pkg',
        {
          params: {
            userid: loginId,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (part) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (part === 0) {
        this._getMyChar();
      } else if (part === 1) {
        this._profileChange();
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _renderItem = () => {
    const { invenList, slideIndex } = this.state;

    const list = invenList.map((item, index) => {
      return (
        <CharItem
          key={index}
          cidx={item.cidx}
          sample_img={item.sample_img}
          sample_name={item.sample_name}
          slideIndex={slideIndex}
        />
        /*<div className="div_li"><img src="img/test_img1.png"/></div>*/
      );
    });

    return list;
  };
  _onToggleMouseOn = () => {
    this.setState({
      mouseOn: true,
    });
  };
  _onToggleMouseOff = () => {
    this.setState({
      mouseOn: false,
    });
  };
  _arrowNext = () => {
    const { slideIndex, invenList } = this.state;
    const cnt = invenList.length;
    const page = Math.round(cnt / 8);

    if (slideIndex < page) {
      this.setState({
        slideIndex: slideIndex + 1,
      });
    }
  };
  _arrowPrev = () => {
    const { slideIndex } = this.state;
    //const cnt = invenList.length;
    //const page = Math.round(cnt / 8);

    //if(slideIndex <= 1) {
    this.setState({
      slideIndex: slideIndex - 1,
    });
    //}
  };
  _onSelect = (key) => {
    const { invenList } = this.state;
    //console.log(key)
    //console.log(invenList[key].sample_img)

    this.setState({
      afterChar: invenList[key].sample_img,
      cidx: invenList[key].cidx,
    });
  };
  _onSelectFile = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        previewURL: reader.result,
        afterChar: reader.result,
        cidx: 0,
      });
    };
    reader.readAsDataURL(file);

    //이미지 업로드 처리.
    this._imgUpload(file);
  };
  _imgUpload = async (file) => {
    const { loginId, aspUrl } = this.props;
    const formData = new FormData();
    formData.append('img', file);
    formData.append('userid', loginId);
    // 서버의 upload API 호출

    await axios.post(aspUrl + '/charImgUpload.asp', formData);
    ////console.log(res)
  };
  _selectImg = () => {
    document.getElementById('imgFile').click();
  };
  _toggleCustomImg = () => {
    const { previewURL } = this.state;
    this.setState({
      //customSelect: !customSelect,
      afterChar: previewURL,
      cidx: 0,
    });
  };
  _profileChange = async () => {
    const { setIcon } = this.props;
    const { afterChar } = this.state;
    //console.log(cidx, afterChar)

    const result = await this._basicChangeApi();
    if (result) {
      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
        //정상적으로 변경됨
        toast.success('캐릭터가 변경되었습니다.');
        setIcon(afterChar);
      } else {
        toast.error('변경중 오류가 발생했습니다.');
      }
    }

    /*
        if(cidx === 0) {
            //fileUpload
        } else {
            //기본이미지로 업데이트
            
        }
        */
  };
  _basicChangeApi = () => {
    const { cidx } = this.state;
    const { loginId, apiUrl, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');

    //console.log(loginId, cidx )

    return axios
      .post(
        apiUrl + '/charChange',
        {
          params: {
            userid: loginId,
            cidx: cidx,
            gubun: cidx === 0 ? 'I' : 'S',
            img: cidx === 0 ? '' : '',
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _cancel = () => {
    const { history } = this.props;
    history.goBack();
  };
  render() {
    const {
      invenList,
      mouseOn,
      slideIndex,
      myCharData,
      afterChar,
      previewURL,
    } = this.state;
    const { imgUrl } = this.props;
    //console.log(mouseOn)
    //console.log(slideIndex)
    let profile_preview = null;
    if (previewURL === '') {
      profile_preview = (
        <img
          className="camera_img"
          src={imgUrl + '/img/mypage/camera.png'}
          style={{ width: 125, height: 125 }}
        ></img>
      );
    } else {
      profile_preview = (
        <img
          className="camera_img"
          src={previewURL}
          style={{ width: 125, height: 125 }}
          onClick={this._toggleCustomImg}
        ></img>
      );
    }
    return (
      <Fragment>
        <div className="content" style={{ position: 'relative' }}>
          <div className="mypge_user_modified">
            <div className="modified_width">
              <h1>
                프로필변경<span>원하시는 캐릭터로 변경하세요.</span>
                <div>
                  <span>
                    <img src={myCharData ? myCharData[0].myCharImg : null} />
                    <em>변경전</em>
                  </span>
                  <span>
                    <img src={afterChar} />
                    <em>변경후</em>
                  </span>
                </div>
              </h1>
              {invenList ? (
                <div className="mypge_modified_group">
                  <h2>
                    기본 캐릭터({invenList.length})
                    <span>
                      애니플러스에서 제공하는 캐릭터를 마음껏 사용하세요.
                    </span>
                  </h2>
                  <div
                    className="div_ul"
                    onMouseEnter={this._onToggleMouseOn}
                    onMouseLeave={this._onToggleMouseOff}
                  >
                    <ScrollMenu
                      data={invenList ? this._renderItem() : null}
                      arrowLeft={
                        mouseOn ? (
                          slideIndex === 1 ? null : (
                            <a
                              style={{ cursor: 'pointer', zIndex: 999999 }}
                              className="pre_btn"
                              onClick={this._arrowPrev}
                            >
                              이전
                            </a>
                          )
                        ) : null
                      }
                      arrowRight={
                        mouseOn ? (
                          slideIndex > parseInt(invenList.length / 8) ? null : (
                            <a
                              style={{ cursor: 'pointer' }}
                              className="next_btn"
                              onClick={this._arrowNext}
                            >
                              다음
                            </a>
                          )
                        ) : null
                      }
                      wheel={false}
                      dragging={false}
                      //transition={0.5}
                      //translate={0}
                      alignOnResize={true}
                      //inertiaScrolling={true}
                      //inertiaScrollingSlowdown={3}
                      //wrapperStyle={{border: 0, backgroundColor: '#000'}}
                      //itemStyle={{verticalAlign: 'text-top'}}
                      alignCenter={false}
                      hideSingleArrow={true}
                      hideArrows={mouseOn}
                      //onUpdate = {this._onUpdate}
                      ref={(ref) => (this.scrollMenu = ref)}
                      //innerWrapperStyle={{textAlign: 'center'}}
                      onSelect={this._onSelect}
                      //rtl={false}
                      scrollBy={8}
                      //selected={selected}
                    />
                    {/*mouseOn ? slideIndex === 1 ? null : (<a style={{cursor: 'pointer'}} className="pre_btn" onClick={this._arrowPrev}>이전</a>) : null*/}
                    {/*mouseOn ? slideIndex > parseInt(invenList.length/8) ? null : (<a style={{cursor: 'pointer'}} className="next_btn" onClick={this._arrowNext} >다음</a>) : null*/}
                    {/*
                                        
                                        
                                        <div className="div_li"><img src="img/test_img1.png"/></div>
                                        <div className="div_li on"><img src="img/test_img1.png"/></div>
                                        <div className="div_li"><img src="img/test_img1.png"/></div>
                                        <div className="div_li"><img src="img/test_img1.png"/></div>
                                        <div className="div_li"><img src="img/test_img1.png"/></div>
                                        <div className="div_li"><img src="img/test_img1.png"/></div>
                                        <div className="div_li"><img src="img/test_img1.png"/></div>
                                        <div className="div_li"><img src="img/test_img1.png"/></div>
                                        */}
                  </div>
                </div>
              ) : null}

              <div
                className="mypge_modified_group"
                style={{ paddingTop: 38, paddingBottom: 38 }}
              >
                <h2>
                  내 전용
                  <span
                    style={{ lineHeight: 1.6, fontWeight: 400, paddingTop: 10 }}
                  >
                    업로드하신 이미지가 음란 / 불법 / 폭력 및 기타 사유로 문제가
                    되는 경우, 삭제될 수 있습니다.
                    <br />( 최대용량 500KB, 이미지 사이즈 : 300px ×300px )
                  </span>
                </h2>
                <a
                  style={{ cursor: 'pointer' }}
                  className="character_btn"
                  onClick={this._selectImg}
                >
                  캐릭터 등록하기
                </a>
                {previewURL === '' ? (
                  <img src={'/img/mypage/camera.png'} className="camera_img" />
                ) : (
                  profile_preview
                )}
                <input
                  type="file"
                  hidden
                  id="imgFile"
                  accept="image/jpg,impge/png,image/jpeg,image/gif"
                  onChange={this._onSelectFile}
                />
              </div>
              <a
                style={{ cursor: 'pointer' }}
                className="mypage_modified_btn"
                onClick={this._profileChange}
              >
                프로필 변경하기
              </a>
              <a
                style={{ cursor: 'pointer', marginTop: 10 }}
                className="mypage_modified_btn"
                onClick={this._cancel}
              >
                취소(뒤로가기)
              </a>
            </div>
          </div>
        </div>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ProfileEdit));
